/**
 * Variant-size-matched "Combine with".
 *
 * The server (snippets/complementary-products.liquid, match_by_size mode) renders one
 * hidden card per configured size the product offers, tagged with data-combine-size-value,
 * and un-hides the one matching the initially selected variant. This script keeps that in
 * sync as the shopper changes options, by listening to the theme's bubbling variant:change
 * event (dispatched on the product form in theme.js) and showing the card whose size value
 * is one of the selected variant's option values.
 */
function updateCombineBySize(variant) {
  const wrappers = document.querySelectorAll('[data-combine-by-size]');
  if (!wrappers.length) return;

  const selected = (variant && variant.options ? variant.options : []).map((value) =>
    String(value).trim().toLowerCase()
  );

  wrappers.forEach((wrapper) => {
    let anyVisible = false;

    wrapper.querySelectorAll('[data-combine-size-value]').forEach((card) => {
      const isMatch = selected.includes(card.getAttribute('data-combine-size-value'));
      card.hidden = !isMatch;
      if (isMatch) anyVisible = true;
    });

    // Hide the whole block (heading included) when the selected size has no mapped vase
    wrapper.hidden = !anyVisible;
  });
}

document.addEventListener('variant:change', (event) => {
  updateCombineBySize(event.detail && event.detail.variant);
});
